import React, { useEffect } from 'react'
import './styles/index.scss'
import { useDispatch, useSelector } from 'react-redux'
import { setIsUserBlock } from 'store/redux-slices/user'
import Icon from 'icons/Icon'
import { openModal } from 'store/redux-slices/modal'
import { MODALS } from 'constants/modals'
import { BUTTON_VARIANT } from 'utils/constants'

const BlockedCountryPageV2 = ({ showModal }) => {
  const { languageData } = useSelector((state) => state.language)
  const { countryBlockFromLogIn } = useSelector((state) => state.user)
  const dispatch = useDispatch()

  useEffect(() => {
    if (showModal && languageData?.countryBlocked) {
      dispatch(openModal({
        name: MODALS?.BLOCKED_COUNTRY_MODAL,
        graphic: <Icon name='blocked-country' height={80} width={140} />,
        title: languageData?.countryBlocked,
        body: `${languageData?.notAcceptingVisitors || ''}\n${languageData?.contactUsAt || ''}\n${process.env.REACT_APP_SUPPORT_MAIL || ''}`,
        onClose: () => dispatch(setIsUserBlock(false)),
        buttons: countryBlockFromLogIn
          ? [
              {
                text: languageData?.close || 'Close',
                variant: BUTTON_VARIANT.SECONDARY
              }
            ]
          : []
      }))
    }
  }, [showModal, languageData, countryBlockFromLogIn, dispatch])

  return null
}

export default BlockedCountryPageV2
